var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trip-banner",on:{"click":_vm.onClickButtonBanner}},[_c('p',{attrs:{"id":"banner-title"}},[_vm._v("アンケートに回答")]),_vm._v(" "),_c('p',{attrs:{"id":"banner-detail"}},[_vm._v("１万円分の景品をゲット！")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5acd11a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/JyutaiSearch/TripSurveyBanner.vue
// module id = null
// module chunks = 